const IndirectExpensesIcon = () => {
  return (
    <svg viewBox="0 0 26.76 30">
      <g transform="translate(-46.191 -30.563)">
        <path d="M54.675,30.572a.69.69,0,0,0-.392.218l-7.612,7.59-.48.5.48.5,7.612,7.59a.7.7,0,1,0,.981-.982l-6.412-6.412H59.692c4.193,0,7.148,1.061,9.051,2.77a8.982,8.982,0,0,1,2.813,7,20.741,20.741,0,0,1-2.683,10.1.7.7,0,1,0,1.178.741,22.134,22.134,0,0,0,2.9-10.84A10.466,10.466,0,0,0,69.681,41.3c-2.225-2-5.559-3.119-9.989-3.119H48.852l6.412-6.412a.7.7,0,0,0-.589-1.2Z" />
      </g>
    </svg>
  );
};

export default IndirectExpensesIcon;
